module.exports = __webpack_public_path__ + "assets/arrow-left-12e7aadeaf1ac23b8d9600dca88d8070.svg";